import { connect } from 'react-redux'
import ExStudent from '../../ViewRole/ExStudent/index'
import rolesSelectors from 'modules/Roles/selectors'

import {
  getRoleViewChart,
  getRoleViewCard,
  getDegreesBasedOnRoles,
  getDegreesBasedExRoles,
  getSingleRoleData,
  getAppliedCandidateList,
  getAppliedCandidateListTrue,
  getCandidateDetails,
  getInstitutesList,
  setInstitutesList,
  createShortList,
  getRoleDraftData,
  jobSharingEmail,
  getPromotion,
} from 'modules/Roles/actions'

import {
  getQuestionaireGraphList,
  getQuestionAndAnswerList,
} from '../../ViewRole/Header/QuestionaireDashboard/actions'

const mapStateToProps = state => ({
  roleViewCardData: rolesSelectors.getRoleViewCard(state),
  roleViewChartData: rolesSelectors.getRoleViewChart(state),
  roleBasedDegreeList: rolesSelectors?.getDegreeRolesList(state),
  roleBasedDegreeExList: rolesSelectors?.getDegreeRolesExList(state),
  singleRoleData: rolesSelectors?.getSingleRoleData(state),
  appliedCandidatesList: rolesSelectors?.getAppliedCandidatesList(state),
  appliedCandidatesListTrue:
    rolesSelectors?.getAppliedCandidatesListTrue(state),
  candidateDetails: rolesSelectors.getCandidateDetails(state),
  institutesList: rolesSelectors.getInstitutesList(state),
  draftData: rolesSelectors.getRoleDraftData(state),
  graphList: rolesSelectors.graphListData(state),
  promotionData: rolesSelectors.getPromotion(state),
})

const mapDispatchToProps = {
  getRoleViewChart,
  getRoleViewCard,
  getDegreesBasedOnRoles,
  getDegreesBasedExRoles,
  getSingleRoleData,
  getAppliedCandidateList,
  getAppliedCandidateListTrue,
  getCandidateDetails,
  getInstitutesList,
  setInstitutesList,
  createShortList,
  jobSharingEmail,
  getRoleDraftData,
  getQuestionaireGraphList,
  getPromotion,
  getQuestionAndAnswerList,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExStudent)
